import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import SwipeableViews from "react-swipeable-views";
import Pagination from "./pagination";

const SwipeWrapper = styled.div`
  &.only-on-mobile {
    width: 100%;
    @media (min-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
      display: none;
    }
  }
  * {
    -ms-overflow-style: none; /* Hide scroll in IE and Edge */
    scrollbar-width: none; /* Hide scroll in Firefox */

    &::-webkit-scrollbar {
      display: none; /* Hide scrollbar for Chrome, Safari and Opera */
    }
  }
`;
const DesktopWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-flow: row nowrap;
  margin: 1rem 0;
  gap: 1rem;
  align-items: stretch;

  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    flex-flow: row wrap;
  }

  &.only-on-desktop {
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
      display: none;
    }
  }
`;
const PaginationWrapper = styled.div`
  background-color: transparent;
  padding: 1rem 0;
  margin-top: -1px;
`;

export default function SwipeContainer({ children }) {
  const [index, setIndex] = useState(0);
  return (
    <>
      <DesktopWrapper className="only-on-desktop">{children}</DesktopWrapper>
      <SwipeWrapper className="only-on-mobile">
        <SwipeableViews
          enableMouseEvents
          index={index}
          onChangeIndex={(index) => setIndex(index)}
          animateHeight
          style={{ height: "auto" }}
        >
          {children}
        </SwipeableViews>

        <PaginationWrapper>
          <Pagination
            dots={
              React.Children.count(children) > 1
                ? React.Children.count(children)
                : 0
            }
            index={index}
            onChangeIndex={(index) => setIndex(index)}
          />
        </PaginationWrapper>
      </SwipeWrapper>
    </>
  );
}

SwipeContainer.propTypes = {
  children: PropTypes.node,
};
SwipeContainer.defaultProps = {
  children: undefined,
};
